import { Button, Checkbox, Modal } from "antd";
import { modeSelector } from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { useEffect, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import checkedIcon from "../../assests/images/checked.svg";
import unCheckedIcon from "../../assests/icons/uncheck.png";
import { useTranslation } from "react-i18next";

export default function SelectAllCard({
  record = [],
  handleSelectAll,
  handleMultiApproveOrReject,
  selectAllChecked,
  handleMultiDelete,
}) {
  const { t } = useTranslation();
  const mode = useSelector(modeSelector);
  const location = useLocation();
  const isPathHistory = location.pathname.includes("/history");
  const isFTPathApprove = location.pathname.includes(
    "/pending-authorization/ft"
  );
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectDetails, setSelectDetails] = useState({});
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  return (
    <div>
      {["VR", "A"].indexOf(mode) > -1 && !isPathHistory ? (
        <div>
          {showGridAccount === "GRID" &&
            (["VR", "A"].indexOf(mode) > -1 && !isPathHistory ? (
              <div
                onClick={() => {
                  handleSelectAll(!selectAllChecked);
                }}
              >
                <span style={{ cursor: "pointer" }}>
                  {selectAllChecked ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      width={17}
                      height={17}
                    />
                  ) : (
                    <img
                      src={unCheckedIcon}
                      alt="unchecked"
                      width={17}
                      height={17}
                    />
                  )}
                </span>
              </div>
            ) : (
              <p></p>
            ))}

          {showGridAccount === "LIST" &&
            (["VR", "A"].indexOf(mode) > -1 && !isPathHistory ? (
              <div
                onClick={() => {
                  handleSelectAll(!selectAllChecked);
                }}
                className="mb-2 mx-2"
              >
                <span style={{ cursor: "pointer" }}>
                  {selectAllChecked ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      width={17}
                      height={17}
                      className="checked"
                    />
                  ) : (
                    <img
                      src={unCheckedIcon}
                      alt="unchecked"
                      width={17}
                      height={17}
                    />
                  )}
                </span>
                <span className="mx-2">
                  {t("pages.pending_approval.select_all", {
                    defaultValue: "Select All",
                  })}
                </span>
              </div>
            ) : (
              <p></p>
            ))}

          <div className="delete-btn-group">
            {["A"].indexOf(mode) > -1 &&
              !isPathHistory &&
              record.filter((ele) => ele.isChecked === true).length > 0 && (
                <>
                  <Button
                    type="default"
                    className="btn-primary mx-2"
                    onClick={() => setShowApproveModal(true)}
                  >
                    {t("pages.pending_approval.approve", {
                      defaultValue: "Approve",
                    })}
                  </Button>
                  <Button
                    type="default"
                    danger
                    onClick={() => setShowRejectModal(true)}
                  >
                    {t("pages.pending_approval.reject", {
                      defaultValue: "Reject",
                    })}
                  </Button>
                </>
              )}
            {["VR"].indexOf(mode) > -1 &&
              !isPathHistory &&
              record.filter((ele) => ele.isChecked === true).length > 0 && (
                <>
                  <Button
                    type="default"
                    className="btn-primary mx-2"
                    onClick={() => setShowVerifyModal(true)}
                  >
                    {t("buttons.verify", {
                      defaultValue: "Verify",
                    })}
                  </Button>
                  <Button
                    type="default"
                    danger
                    onClick={() => setShowRejectModal(true)}
                  >
                    {t("pages.pending_approval.reject", {
                      defaultValue: "Reject",
                    })}
                  </Button>
                </>
              )}
            {["A", "VR"].indexOf(mode) > -1 &&
              isFTPathApprove &&
              record.filter((ele) => ele.isChecked === true).length > 0 && (
                <>
                  <Button
                    type="default"
                    className="secondary-btn mx-2 hide-xs"
                    onClick={() => setShowReturnModal(true)}
                  >
                    {t("buttons.return_btn", {
                      defaultValue: "Return",
                    })}
                  </Button>
                </>
              )}
          </div>
        </div>
      ) : null}

      {["I"].indexOf(mode) > -1 && !isPathHistory ? (
        <div className="d-flex justify-content-between">
          <div>
            {showGridAccount === "GRID" &&
              (["I"].indexOf(mode) > -1 && !isPathHistory ? (
                <div
                  onClick={() => {
                    handleSelectAll(!selectAllChecked);
                  }}
                >
                  <span style={{ cursor: "pointer" }}>
                    {selectAllChecked ? (
                      <img
                        src={checkedIcon}
                        alt="checked"
                        width={17}
                        height={17}
                        className="checked"
                      />
                    ) : (
                      <img
                        src={unCheckedIcon}
                        alt="unchecked"
                        width={17}
                        height={17}
                        className="unchecked"
                      />
                    )}
                  </span>
                </div>
              ) : (
                <p></p>
              ))}

            {showGridAccount === "LIST" &&
              (["I"].indexOf(mode) > -1 && !isPathHistory ? (
                <div
                  onClick={() => {
                    handleSelectAll(!selectAllChecked);
                  }}
                  className="mb-2 mx-2"
                >
                  <span style={{ cursor: "pointer" }}>
                    {selectAllChecked ? (
                      <img
                        src={checkedIcon}
                        alt="checked"
                        width={17}
                        height={17}
                        className="checked"
                      />
                    ) : (
                      <img
                        src={unCheckedIcon}
                        alt="unchecked"
                        width={17}
                        height={17}
                        className="unchecked"
                      />
                    )}
                  </span>
                  <span className="mx-2">
                    {t("pages.pending_approval.select_all", {
                      defaultValue: "Select All",
                    })}
                  </span>
                </div>
              ) : (
                <p></p>
              ))}
          </div>
          <div className="delete-btn-group">
            {["I"].indexOf(mode) > -1 &&
              !isPathHistory &&
              record.filter((ele) => ele.isChecked === true).length > 0 && (
                <>
                  <Button
                    type="default"
                    className="btn-primary mx-2"
                    onClick={() => {
                      setSelectDetails(record);
                      setShowModal(true);
                    }}
                  >
                    {t("pages.pending_approval.delete", {
                      defaultValue: "Delete",
                    })}
                  </Button>
                </>
              )}
          </div>
        </div>
      ) : null}

      <Modal
        closable={false}
        maskClosable={false}
        open={showModal}
        footer={null}
        width={450}
        mask={true}
      >
        <div
          style={{ width: 320, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <AiOutlineInfoCircle size={55} className="primary-color" />
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.pending_approval.delete_selected_txt", {
              defaultValue: "Do you want to delete the selected records?",
            })}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              style={{ width: 120 }}
              size="large"
              className="secondary-btn"
              onClick={() => setShowModal(false)}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
            <Button
              type="primary"
              className="primary-btn"
              style={{ width: 120, marginLeft: 20 }}
              size="large"
              onClick={() => {
                handleMultiDelete(selectDetails);
                setShowModal(false);
              }}
            >
              {t("buttons.yes_btn", {
                defaultValue: "Yes",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        closable={false}
        maskClosable={false}
        open={showApproveModal}
        footer={null}
        width={450}
        mask={true}
      >
        <div
          style={{ width: 340, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <AiOutlineInfoCircle size={55} className="primary-color" />
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.pending_approval.approve_selected_txt", {
              defaultValue: "Do you want to approve the selected records?",
            })}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              style={{ width: 120 }}
              size="large"
              className="secondary-btn"
              onClick={() => setShowApproveModal(false)}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
            <Button
              size="large"
              type="primary"
              className="primary-btn"
              style={{ width: 120, marginLeft: 20 }}
              onClick={() => {
                handleMultiApproveOrReject("A");
                setShowApproveModal(false);
              }}
            >
              {t("buttons.yes_btn", {
                defaultValue: "Yes",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        closable={false}
        maskClosable={false}
        open={showVerifyModal}
        footer={null}
        width={450}
        mask={true}
      >
        <div
          style={{ width: 340, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <AiOutlineInfoCircle size={55} className="primary-color" />
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.pending_approval.verify_selected_txt", {
              defaultValue: "Do you want to verify the selected records?",
            })}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              style={{ width: 120 }}
              size="large"
              className="secondary-btn"
              onClick={() => setShowVerifyModal(false)}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
            <Button
              size="large"
              type="primary"
              className="primary-btn"
              style={{ width: 120, marginLeft: 20 }}
              onClick={() => {
                handleMultiApproveOrReject("A");
                setShowVerifyModal(false);
              }}
            >
              {t("buttons.yes_btn", {
                defaultValue: "Yes",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        closable={false}
        maskClosable={false}
        open={showRejectModal}
        footer={null}
        width={450}
        mask={true}
      >
        <div
          style={{ width: 320, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <AiOutlineInfoCircle size={55} className="primary-color" />
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.pending_approval.reject_selected_txt", {
              defaultValue: "Do you want to reject the selected records?",
            })}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              style={{ width: 120 }}
              size="large"
              className="secondary-btn"
              onClick={() => setShowRejectModal(false)}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
            <Button
              size="large"
              type="primary"
              className="primary-btn"
              style={{ width: 120, marginLeft: 20 }}
              onClick={() => {
                handleMultiApproveOrReject("R");
                setShowRejectModal(false);
              }}
            >
              {t("buttons.yes_btn", {
                defaultValue: "Yes",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        closable={false}
        maskClosable={false}
        open={showReturnModal}
        footer={null}
        width={450}
        mask={true}
      >
        <div
          style={{ width: 320, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <AiOutlineInfoCircle size={55} className="primary-color" />
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.pending_approval.return_selected_txt", {
              defaultValue: "Do you want to return the selected records?",
            })}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              style={{ width: 120 }}
              size="large"
              className="secondary-btn"
              onClick={() => setShowReturnModal(false)}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
            <Button
              size="large"
              type="primary"
              className="primary-btn"
              style={{ width: 120, marginLeft: 20 }}
              onClick={() => {
                handleMultiApproveOrReject("RN");
                setShowReturnModal(false);
              }}
            >
              {t("buttons.yes_btn", {
                defaultValue: "Yes",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
